// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__Il7l6"};